export const GET_CURRENCY_REQUEST = 'GET_CURRENCY_REQUEST';
export const GET_CURRENCY_DATA = 'GET_CURRENCY_DATA';
export const GET_CURRENCY_ERROR = 'GET_CURRENCY_ERROR';

export const CREATE_CURRENCY_REQUEST = 'CREATE_CURRENCY_REQUEST';
export const CREATE_CURRENCY_DATA = 'CREATE_CURRENCY_DATA';
export const CREATE_CURRENCY_ERROR = 'CREATE_CURRENCY_ERROR';

export const UPDATE_CURRENCY_REQUEST = 'UPDATE_CURRENCY_REQUEST';
export const UPDATE_CURRENCY_DATA = 'UPDATE_CURRENCY_DATA';
export const UPDATE_CURRENCY_ERROR = 'UPDATE_CURRENCY_ERROR';

export const DELETE_CURRENCY_REQUEST = 'DELETE_CURRENCY_REQUEST';
export const DELETE_CURRENCY_DATA = 'DELETE_CURRENCY_DATA';
export const DELETE_CURRENCY_ERROR = 'DELETE_CURRENCY_ERROR';
